import { Header } from 'components/Header'
import React from 'react'
import { Helmet } from 'react-helmet'

export type SiteHeaders = 'Header 1' | 'Header 2' | 'Header 3'

interface SiteHeaderProps {
  searchEngine: boolean
}

const SiteHeader: React.FC<SiteHeaderProps> = ({ searchEngine }) => {
  const anchorRef = React.useRef<HTMLDivElement>(null)

  const renderHeader = () => {
    const headerClassName = 'shadow-sm dark:border-b dark:border-neutral-700'
    return <Header className={headerClassName} searchEngine={searchEngine} />
  }

  return (
    <>
      <Helmet>
        <title>Virotrip - Backoffice RH</title>
      </Helmet>
      {renderHeader()}
      <div ref={anchorRef} className="h-1 absolute invisible"></div>
    </>
  )
}

export default SiteHeader
